module.exports = __webpack_public_path__ + "img/story.d34fdaac.jpg";